import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-area",
  "use": "icon-area-usage",
  "viewBox": "0 0 1170 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1170 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-area\"><path d=\"M1170.285714 877.714286v73.142857H0V73.142857h73.142857v804.571429h1097.142857zM950.857143 292.571429l146.285714 512H146.285714v-329.142858l256-329.142857 329.142857 329.142857z\" p-id=\"4112\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol